"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UrlFormatError extends Error {
    constructor(url, re) {
        const message = `${url} does not match ${re}.`;
        super(message);
        this.url = url;
        this.re = re;
    }
}
exports.default = UrlFormatError;
